import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OidcBaseComponent } from './oidc-base.component';
import { FooterModule, SharedModule } from 'merlin-library';
import { environment } from 'src/environments/environment';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: OidcBaseComponent,
  },
];

@NgModule({
  declarations: [OidcBaseComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule.forRoot(environment),
    FooterModule
  ]
})
export class OidcModule { }
